import React from 'react'
import classNames from 'classnames'
import { nanoid } from 'nanoid'
import NavLink from './NavLink'

const NavigationDesktop = ({ navItems, location }) => {
  return (
    <nav className="hidden lg:flex lg:justify-center	lg:items-center lg:gap-12 lg:ml-12">
      {navItems.map(item => (
        <NavLink
          key={`nav-desktop-${nanoid()}`}
          className={classNames(
            'typo-bold-16 text-secondary hover:text-primary',
            {
              'text-primary underline decoration-solid decoration-primary decoration-2 underline-offset-4':
                location?.pathname === item.path,
            }
          )}
          to={item.path}
          static={item.static}
        >
          {item.text}
        </NavLink>
      ))}
    </nav>
  )
}

export default NavigationDesktop
